import React, { FC } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { EnterpriseRanking } from '../../../../model/Ranking'
import FlatButton from '../../../../components/buttons/flat_button'
import { RankIcon } from '../../../../images/icons/rank_icon'

type IndustryRankingSectionProps = {
  industryCode: string
  industryName: string
  rankings: Array<EnterpriseRanking>
}

const IndustryRankingSection: FC<IndustryRankingSectionProps> = (props) => {
  const navigate = useNavigate()

  return (
    <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-4">
      <h3 className="font-bold text-xl text-main-black border-b border-gray-200 pb-2 mb-3">
        {props.industryName}
      </h3>

      <div className="space-y-1 min-h-[250px]">
        {props.rankings.map((ranking, index) => (
          <Link
            key={`industry-ranking-${props.industryCode}-${index}`}
            to={`/enterprises/${ranking.enterprise.id}`}
          >
            <div className="flex items-center hover:bg-gray-50 rounded py-2 transition-colors">
              <div className="flex-shrink-0 mr-3">
                <RankIcon rank={ranking.rank} />
              </div>
              <div className="flex-1 flex items-center justify-between min-w-0">
                <p className="font-normal text-base truncate mr-3">
                  {ranking.enterprise ? ranking.enterprise.name : ''}
                </p>
                <div className="flex items-center flex-shrink-0">
                  <span className="text-main-blue text-base mr-1">★</span>
                  <span className="text-main-black text-base font-medium mr-1">
                    {ranking.enterprise.evaluationAverage
                      ? ranking.enterprise.evaluationAverage.toFixed(2)
                      : '-'}
                  </span>
                  <span className="text-main-darkGray text-base">
                    (
                    {ranking.enterprise && ranking.enterprise.kuchikomiCount
                      ? ranking.enterprise.kuchikomiCount.toLocaleString()
                      : '0'}
                    )
                  </span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-3 flex justify-center">
        <FlatButton
          size="sm"
          onClick={() =>
            navigate(
              `/ranking/enterprise?group=industry&groupValue=${props.industryCode}`
            )
          }
        >
          もっと見る
        </FlatButton>
      </div>
    </div>
  )
}

export default IndustryRankingSection
